import Vue from 'vue';
import Message from '@/utils/message';

/**
 * 导出，处理下载文件流
 * @param {Blob} blob 文件流
 * @param {String} name 下载文件名
 * @param {String} suffix 文件后缀名
 */
Vue.prototype.$exportClick = function(blob, name, suffix = '.xls') {
  const reader = new FileReader();
  reader.readAsText(blob, 'utf-8');
  reader.onload = () => {
    try {
      const { message } = JSON.parse(reader.result); // 对象数据，后台转换失败
      Message.error(message);
    } catch (e) {
      // 正常的文件流，解析成对象失败
      const fileName = name + suffix;
      downloadFile(fileName, blob);
    }
  };
};

// 下载文件
function downloadFile(fileName, blob) {
  if ('download' in document.createElement('a')) {
    // 非IE
    const link = document.createElement('a');
    link.download = fileName;
    link.style.display = 'none';
    link.href = URL.createObjectURL(blob);
    document.body.appendChild(link);
    link.click();
    URL.revokeObjectURL(link.href);
    document.body.removeChild(link);
  } else {
    // IE10+
    navigator.msSaveBlob(blob, fileName);
  }
}
